import { ADICIONAR_FILTRO_TOMADOR } from '../../types'

export default function adicionarFiltroTomador (filtro) {
  return {
    type: ADICIONAR_FILTRO_TOMADOR,
    payload: filtro
  }
}
